interface FallbackBlockProps {
  blocktype: string;
}
export const FallbackBlock = ({ blocktype }: FallbackBlockProps) => {
   
  console.warn(`No component found for: ${blocktype}`);
  return null;
};
